import { useCallback, useEffect, useState } from "react";
import DashboardHeader from "./components/DashboardHeader";
import Firstsection from "./components/Firstsection";
import SecondSection from "./components/SecondSection";
import ThirdSection from "./components/ThirdSection";
// import FourthSection from "./components/FourthSection";
// import RecentTransaction from "./components/RecentTransaction";
import AdminBalanceCard from "./components/AdminBalanceCard";
import {
  getStatistics,
  // statisticByMonth,
  // getLatestTransactions,
  getAdminCommData,
  getStatisticsPayin,
  getStatisticsPayout,
  getWebhookRatio,
} from "../../config/LiveApi";
import { get } from "../../config/axios";
import "./components/MerchantDashboard.css";
import { ShimmerSimpleGallery, ShimmerThumbnail } from "react-shimmer-effects";
import { useDispatch, useSelector } from "react-redux";
import { resetValues } from "../../redux/slices/userSlice";

export const maskValue = (value, show) => (show ? "****" : value);
function MerchantDashboard() {
  let token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [depositeWithdrawl, setDepositeWithdrawl] = useState(null);
  const [boxLoading, setBoxLoading] = useState(false);
  const [cardsData, setCardsData] = useState(null);
  const [firstSectionLoading, setFirstSectionLoading] = useState(false);
  const [statisticLoading, setStatisticLoading] = useState(false);
  const [payInStatistic, setPayinStatistic] = useState(null);
  const [payoutStatistic, setPayoutStatistic] = useState(null);
  // const [barLoading, setBarLoading] = useState(false);
  // let [payinMonth, setPayinMonth] = useState([]);
  // let [payOutMonth, setPayoutMonth] = useState([]);
  const [finalLoading, setFinalLoading] = useState(false);
  // let [series, setSeries] = useState([]);
  // const [latestTxns, setLatestTxns] = useState(null);
  const [adminComm, setAdminComm] = useState(null);
  const [commLoading, setCommLoading] = useState(true);
  const [webhookRatio, setWebhookRatio] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetValues()); // resets hide/show flag
    };
  }, []);

  const fetchStatistic = async (token, startDate, endDate) => {
    setStatisticLoading(true);
    setFirstSectionLoading(true);

    const data = await getStatistics(token, startDate, endDate);
    setPayinStatistic(data.payIn);
    setPayoutStatistic(data.payout);
    setStatisticLoading(false);
    setFirstSectionLoading(false);
  };

  const fetchPayinStatistic = async (token, startDate, endDate) => {
    setStatisticLoading(true);
    setFirstSectionLoading(true);
    const data = await getStatisticsPayin(token, startDate, endDate);
    setPayinStatistic(data.payIn);
    // setPayoutStatistic(data.payout);

    setStatisticLoading(false);
    // dataFrom(token)
  };

  const fetchAdminComm = useCallback(
    async (startDate, endDate) => {
      setCommLoading(true);

      const data = await getAdminCommData(token, startDate, endDate);
      setAdminComm(data);

      setCommLoading(false);
    },
    [token]
  );

  const fetchPayoutStatistic = useCallback(
    async (token, startDate, endDate, role) => {
      try {
        setFirstSectionLoading(true);
        setStatisticLoading(true);

        const data = await getStatisticsPayout(token, startDate, endDate);
        setPayoutStatistic(data.payout);

        if (role === "super" || role === "subSuper") {
          fetchAdminComm(startDate, endDate);
        }
      } catch (error) {
        console.error("Error fetching payout statistics:", error);
      } finally {
        setStatisticLoading(false);
        setFirstSectionLoading(false);
      }
    },
    [fetchAdminComm]
  );
  const fetchWebhookRatio = async () => {
    try {
      const data = await getWebhookRatio();

      setWebhookRatio(data);
    } catch (error) {
      console.error("Error fetching webhook ratio:", error);
    }
  };

  useEffect(() => {
    setFinalLoading(true);
    const now = new Date();

    now.setHours(0, 0, 0, 0);
    const isoDateString = now.toISOString();
    const nowDays = new Date();
    const isoDateCurrent = nowDays.toISOString();

    setStartDate(isoDateString);
    setEndDate(isoDateString);

    fetchPayinStatistic(token, isoDateString, isoDateCurrent);
    fetchPayoutStatistic(token, isoDateString, isoDateCurrent, role);
    if (role !== "admin" && role !=="subAdmin") {
      fetchWebhookRatio();
    }
    setFinalLoading(false);
  }, [role, token, fetchPayoutStatistic]);

  // const dataFrom = async (token) => {
  //   setBarLoading(true);
  //   setPayinMonth([]);
  //   setPayoutMonth([]);
  //   series = [];
  //   const data = await statisticByMonth(token);

  //   const monthNames = [
  //     "January",
  //     "February",
  //     "March",
  //     "April",
  //     "May",
  //     "June",
  //     "July",
  //     "August",
  //     "September",
  //     "October",
  //     "November",
  //     "December",
  //   ];

  //   const orderedPayIn = Array(12).fill(0);
  //   const orderedPayOut = Array(12).fill(0);

  //   data?.data?.payIn.forEach(({ monthName, amount }) => {
  //     const index = monthNames.indexOf(monthName);
  //     if (index !== -1) {
  //       orderedPayIn[index] = { monthName, amount };
  //     }
  //   });

  //   data?.data?.payOut.forEach(({ monthName, amount }) => {
  //     const index = monthNames.indexOf(monthName);
  //     if (index !== -1) {
  //       orderedPayOut[index] = { monthName, amount };
  //     }
  //   });

  //   orderedPayIn?.map((item) => payinMonth.push(item.amount.toFixed(2)));
  //   orderedPayOut?.map((item) => payOutMonth.push(item.amount.toFixed(2)));

  //   setSeries([
  //     {
  //       name: "PayIn",
  //       data: payinMonth,
  //     },
  //     {
  //       name: "Payout",
  //       data: payOutMonth,
  //     },
  //   ]);
  //   setBarLoading(false);
  // };

  const fetchData = async (startDate, endDate) => {
    setBoxLoading(true);
    try {
      const response = await get(
        `v1/admin/transactions/data?startDate=${startDate}&&endDate=${endDate}`
      );

      setDepositeWithdrawl(response.meta);
      setCardsData(response.dashboardCardsForMerchants);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setBoxLoading(false);
  };

  // const fetchLatestTransaction = async () => {
  //   setBoxLoading(true);
  //   try {
  //     const token = useSelector((store) => store.userReducer.token);
  //     const response = await getLatestTransactions(token);
  //     setLatestTxns(response.latestTransactions);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  //   setBoxLoading(false);
  // };

  useEffect(() => {
    const isoDateRanges = [];
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    for (let i = 6; i >= 0; i--) {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - i);
      currentDate.setHours(0, 0, 0, 0);

      const startDateISO = currentDate.toISOString();
      currentDate.setHours(23, 59, 59, 999);
      const endDateISO = currentDate.toISOString();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      const dayOfWeek = daysOfWeek[currentDate.getDay()];

      isoDateRanges.push({
        date: formattedDate,
        dayOfWeek,
        startDateISO,
        endDateISO,
      });
    }
  }, []);

  return (
    <>
      {finalLoading ? (
        <></>
      ) : (
        <div>
          <DashboardHeader
            fetchData={fetchData}
            fetchStatistic={fetchStatistic}
            fetchPayinStatistic={fetchPayinStatistic}
            fetchPayoutStatistic={fetchPayoutStatistic}
          />

          {firstSectionLoading ? (
            <ShimmerSimpleGallery
              className="shimmer-effect"
              row={2}
              col={3}
              imageHeight={100}
            />
          ) : (
            <div>
              <Firstsection
                payInStatistic={payInStatistic}
                payoutStatistic={payoutStatistic}
                webhookRatio={webhookRatio}
              />
            </div>
          )}

          {(role === "super" || role == "subSuper") && (
            <div>
              {commLoading ? (
                <ShimmerThumbnail
                  className="shimmer-effect"
                  height={100}
                  rounded
                />
              ) : (
                <AdminBalanceCard adminComm={adminComm} />
              )}
            </div>
          )}

          {statisticLoading ? (
            <ShimmerSimpleGallery
              className="shimmer-effect"
              row={1}
              col={2}
              imageHeight={300}
            />
          ) : (
            <SecondSection
              payInStatistic={payInStatistic}
              payoutStatistic={payoutStatistic}
            />
          )}

          {statisticLoading ? (
            <ShimmerSimpleGallery
              className="shimmer-effect"
              row={1}
              col={2}
              imageHeight={300}
            />
          ) : (
            <ThirdSection payoutStatistic={payoutStatistic} />
          )}

          {/* <div className="new-section mar-chart">
            {barLoading ? (
              <ShimmerThumbnail
                className="shimmer-effect"
                height={300}
                rounded
              />
            ) : (
              <FourthSection series={series} />
            )}
          </div> */}

          {/* <div className="mar-chart">
            {latestTxns && (
              <RecentTransaction latestTxns={fetchLatestTransaction} />
            )}
          </div> */}
        </div>
      )}
    </>
  );
}

export default MerchantDashboard;
